import React, { useReducer, useMemo } from "react";

import CloseIcon from "@mui/icons-material/Close";
import { IconButton, Snackbar } from "@mui/material";

type State = {
  open: boolean;
  message: string;
};

type Action =
  | { type: "close-snackbar" }
  | { type: "open-snackbar"; payload: string };

type SnackBarHelper = {
  open: (message: string) => void;
  /**
   * @deprecated
   */
  openSnackBar: (message: State["message"]) => void;
};

type SimpleSnackBar = () => JSX.Element;

type ReturnType = [SimpleSnackBar, SnackBarHelper];

const initialState: State = {
  open: false,
  message: "",
};

function reducer(state: State, action: Action) {
  switch (action.type) {
    case "close-snackbar":
      return initialState;
    case "open-snackbar":
      return { open: true, message: action.payload };
    default:
      return state;
  }
}

export const useSnackBar = (): ReturnType => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const snackBarHelpers: SnackBarHelper = {
    open: (message: State["message"]) =>
      dispatch({ type: "open-snackbar", payload: message }),
    openSnackBar: (message: State["message"]) =>
      dispatch({ type: "open-snackbar", payload: message }),
  };
  const SimpleSnackBar = useMemo(
    () =>
      function SnackBar() {
        return (
          <Snackbar
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
            open={state.open}
            autoHideDuration={3000}
            onClose={() => dispatch({ type: "close-snackbar" })}
            message={state.message}
            action={
              <React.Fragment>
                <IconButton
                  size="small"
                  aria-label="close"
                  color="inherit"
                  onClick={() => dispatch({ type: "close-snackbar" })}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </React.Fragment>
            }
          />
        );
      },
    [state]
  );
  return [SimpleSnackBar, snackBarHelpers];
};
